'use strict';

const generate = require('nanoid/generate');

export default {
  consoleLog: log => {
    if (process.env.NODE_ENV !== 'production') console.log(log);
  },
  parsePartnerList: partnerList => {
    if (!partnerList || partnerList === '{}') {
      return {};
    }

    return JSON.parse(partnerList
      .replace(/{/g, '{"')
      .replace(/=/g, '":"')
      .replace(/, /g, '","')
      .replace(/}/g, '"}')
    );
  },
  setHeader: () => {
    const header = {
      headers: {
        'X-Api-Key': process.env.VUE_APP_API_KEY,
      },
    };
    return header;
  },
  setHeaderWithAuthorization: () => {
    const header = {
      headers: {
        'X-Api-Key': process.env.VUE_APP_API_KEY,
        Authorization: document.cookie,
      },
    };
    return header;
  },
  setHeaderWithToken: () => {
    const header = {
      headers: {
        'X-Api-Key': process.env.VUE_APP_API_KEY,
        Token: document.cookie,
      },
    };
    return header;
  },
  setupLINELogin: function() {
    // XSRF対策
    const state = generate('abcdefghijklmnopqrstuvwxyz0123456789', 8);
    localStorage.setItem('state', state);

    const url =
      'https://access.line.me/oauth2/v2.1/authorize' +
      '?response_type=code' +
      `&client_id=${process.env.VUE_APP_LINE_CLIENT_ID}` +
      `&redirect_uri=${process.env.VUE_APP_REDIRECT_URL}` +
      `&state=${state}` +
      '&scope=profile';

    return url;
  },
  /**
   * APIのレスポンスを取得できているか確認する
   *
   * @param {Object} res APIのレスポンスをまとめたオブジェクト
   * @return {boolean} 正しい: true, 間違い: false
   */
  parseAPIResponse: function(res) {
    if (!res.profile) {
      return false;
    }
    else if (!res.memories) {
      return false;
    }

    let partnerCount = 0;
    res.partners.forEach(partner => {
      if (partner) partnerCount++;
    });

    // パートナーが取得できているかどうか
    return Object.keys(res.profile.partnerList).length === partnerCount;
  },
};
